import Cmp from './ad-cmp-loader';

class AdPaidTaboola {
  constructor() {
    window._taboola = window._taboola || [];
    window._taboola.push({ article: 'auto' });

    // Notes for Consent Manager integration
    // https://www.taboola.com/documents/consent-management-technical-integration-guidelines-publishers.pdf

    // eslint-disable-next-line camelcase
    const script = document.createElement('script');
    script.async = true;
    script.id = 'tb_loader_script';
    script.src = '//cdn.taboola.com/libtrc/stroeergamma-hildesheimer/loader.js';

    const cmp = new Cmp();
    // eslint-disable-next-line max-len
    // NOTE We don't need the vendorId actually as we disregard it, still we submit it for console output
    cmp.waitForConsent(script, 42);

    if (window.performance && typeof window.performance.mark === 'function') {
      window.performance.mark('tbl_ic');
    }

    script.onload = () => {
      window._taboola = window._taboola || [];
      window._taboola.push({
        mode: 'thumbnails-a',
        container: 'taboola-widget-plus-article',
        placement: 'Widget Plus Article',
        target_type: 'mix',
      });
    };
  }
}

export default AdPaidTaboola;
